import { createSimpleEmitter } from '../../@core/utilities/Emitter'
import { useEffect, useState } from 'react'
import { getIsServer } from '../../utilities/common'
const { emitAll, regiterCallback, unregisterCallBack } = createSimpleEmitter<any>()
export const useLocalStorageState = <T>(): [T, (srg: T) => void, () => void] => {
  const [state, setState] = useState<T>(
    getIsServer() ? {} : localStorage.getItem('@apply_process') ? JSON.parse(localStorage.getItem('@apply_process')) : undefined
  )
  const setLocalStorageState = (state: T) => {
    localStorage.setItem('@apply_process', state ? JSON.stringify(state) : '')
    emitAll(state)
  }
  const onEvent = (args) => {
    return Promise.resolve(setState(args))
  }
  useEffect(() => {
    regiterCallback(onEvent)
    return () => {
      unregisterCallBack(onEvent)
    }
  }, [])
  return [
    state,
    setLocalStorageState,
    () => {
      localStorage.setItem('@apply_process', '')
      setState(undefined)
    }
  ]
}
